module.exports = __webpack_public_path__ + "static/img/HU@3x.9ea7b96a.jpg";